import React from 'react';
import { Modal, Button } from 'antd';
import PropTypes from 'prop-types';
import styles from '../../styles/modal.module.scss';

const DeleteModal = ({
  visible,
  onDelete,
  onCancel,
  loading,
  title,
  message,
  buttonText,
  cancelText,
}) => (
  <Modal open={visible} footer={null} closeIcon={null} onCancel={onCancel}>
    <div className={styles.modal}>
      {title && <p className={styles.modal__title}>{title}</p>}
      {message && <p className={styles.modal__message}>{message}</p>}
      {buttonText && (
        <div className={styles.modal__buttons}>
          <Button
            className={`btn-tertiary`}
            onClick={onCancel}
            disabled={loading}
          >
            <span>{cancelText}</span>
          </Button>
          <Button
            className={`btn-primary red-button`}
            onClick={onDelete}
            disabled={loading}
          >
            <img src="/assets/icons/delete-white.svg" alt="Delete Icon" />
            <span style={{ marginLeft: '8px' }}>
              {loading ? 'Brisanje...' : buttonText}
            </span>
          </Button>
        </div>
      )}
    </div>
  </Modal>
);

DeleteModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onDelete: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  title: PropTypes.string,
  message: PropTypes.string.isRequired,
  buttonText: PropTypes.string,
};

export default DeleteModal;
